// ============================================================================
// Table Columns: ContactCodeTrees
// Key: contactCodeTrees
// Generated file. Do not edit manually.
// ============================================================================

// #region Imports
import {
	cellRenderer,
	type EntityTableConfig,
	enumRenderer,
} from '../../entity-config-runtime/entity-table-config'
import type { ContactCodeTreeSummary } from '../api/backstage.schemas'
import { ContactCodeType } from '../api/backstage.schemas'
// #endregion

// #region Entity List Columns
export const contactCodeTreesListColumnsConfig = {
	columns: [
		'name',
		cellRenderer('isDefault', 'boolean'),
		cellRenderer('contactCodeCount', 'number'),
		cellRenderer('queueCount', 'number'),
		cellRenderer('childrenCound', 'number'),
		enumRenderer('type', ContactCodeType, 'ContactCodeType'),
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
	],
	actions: [
		{
			type: 'link',
			id: 'id',
			label: 'tables_actions_detail',
			icon: 'ArrowRight',
			style: 'link',
			href: (row: ContactCodeTreeSummary) =>
				`/contactCodeTrees/${row.id}/details`,
		},
	],
} as const satisfies EntityTableConfig<ContactCodeTreeSummary>
// #endregion

// #region Columns Config Export
export const contactCodeTreesColumnsConfig = {
	list: contactCodeTreesListColumnsConfig,
} as const
// #endregion
